$(function () {
  // Init teaser slider
  $('.hero__container').slick({
    infinite: true,
    arrows: false,
    dots: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 6000
  });

  // Add enter events
  $('[data-trigger-click-on-enter]').on(
    'keypress.triggerClickOnEnter',
    function (e) {
      if (e.which == 13) {
        $(this).trigger('click');
      }
    }
  );

  // Remove tab links
  $('.slick-dots button').attr('tabindex', -1);

  // Video thumbnails
  if (localStorage.getItem('googleYouTubeAccepted')) {
    $('.article-images__image-video[data-video-thumbnail]').each(function (index, item) {
      $(item).css({ backgroundImage: 'url(\'' + $(item).attr('data-video-thumbnail') + '\')' });
    });
  }

  // Add DSGVO accepted classes
  if (localStorage.getItem('googleYouTubeAccepted') == 1) {
    $('body').addClass('google-youtube-accepted');
  }

  if (localStorage.getItem('googleMapsAccepted') == 1) {
    $('body').addClass('google-maps-accepted');
  }

  // Matomo
  var _paq = window._paq = window._paq || [];
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  _paq.push(['setSecureCookie', true]);
  (function () {
    var u = "//analytics.oekomodellregionen.bayern/";
    _paq.push(['setTrackerUrl', u + 'matomo.php']);
    _paq.push(['setSiteId', '1']);
    var d = document, g = d.createElement('script'), s = d.getElementsByTagName('script')[0];
    g.async = true; g.src = u + 'matomo.js'; s.parentNode.insertBefore(g, s);
  })();
});
